export const TENANT_REQUIRED_MESSAGE = "Please register an Tenant first.";

export function isTenantRequiredError(error) {
  return error?.response?.status === 404 &&
    error?.response?.data?.message === TENANT_REQUIRED_MESSAGE;
}
